export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";